<template>
	<div>
		<div class="content" id="remote-table">
			<p>
				If you need to fetch items from a remote backend, you can use the <code>UiRemoteTable</code> component.<br>
				The <code>api</code> property accepts both an url (absolute or relative) and an axios request configuration object (<a href="https://github.com/axios/axios#request-config" target="_blank">https://github.com/axios/axios#request-config</a>)
			</p>
			<pre v-highlightjs class="box pa-0"><code class="html" v-pre>&lt;template&gt;
	&lt;ui-remote-table api=&quot;https://reqres.in/api/colors&quot;
						:get-pagination-params=&quot;getPaginationParams&quot;
						:parse-response=&quot;parseResponse&quot;
						:row-style=&quot;rowStyle&quot;
						pagination
						borderless&gt;
		&lt;ui-table-column prop=&quot;id&quot; header=&quot;#ID&quot;/&gt;
		&lt;ui-table-column prop=&quot;name&quot; header=&quot;Name&quot;/&gt;
		&lt;ui-table-column prop=&quot;year&quot; header=&quot;Year&quot;/&gt;
		&lt;ui-table-column prop=&quot;pantone_value&quot; header=&quot;Pantone&quot;/&gt;
	&lt;/ui-remote-table&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
		name: &quot;remote-table&quot;,
		methods: {
			getPaginationParams({ max, page }) {
				return { params: { page, per_page: max, delay: 5 }}
			},
			parseResponse({ data }) {
				const items = data.data
				const totalItems = data.total
				const max = data.per_page
				const page = data.page
				return { items, totalItems, page, max }
			},
			rowStyle(item) { return `background-color: ${item.color};` }
		}
	}
&lt;/script&gt;</code></pre>
		</div>
		<ui-remote-table api="https://reqres.in/api/colors" container-class="box" :get-pagination-params="getPaginationParams" :parse-response="parseResponse" :row-style="rowStyle" pagination borderless>
			<ui-table-column prop="id" header="#ID"/>
			<ui-table-column prop="name" header="Name"/>
			<ui-table-column prop="year" header="Year"/>
			<ui-table-column prop="pantone_value" header="Pantone"/>
		</ui-remote-table>
	</div>
</template>

<script>
    export default {
        name: "remote-table",
		methods: {
            getPaginationParams({ max, page }) {
                return { params: { page, per_page: max, delay: 5 }}
			},
            parseResponse({ data }) {
                const items = data.data
				const totalItems = data.total
				const max = data.per_page
				const page = data.page
                return { items, totalItems, page, max }
			},
			rowStyle(item) { return `background-color: ${item.color};` }
		}
    }
</script>